function routineHeaders() {
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` };
}

export interface RecentRoutineRun {
  id: number;
  routineId: string;
  routineName: string;
  status: 'done' | 'failed' | 'running' | string;
  startedAt: string;
  finishedAt?: string;
  durationSec?: number;
}

// Last N runs across ALL of the current user's routines — backs the
// /momentum-routines right-sidebar "Recent Runs" feed.
export async function getRecentRoutineRuns(limit = 10): Promise<RecentRoutineRun[]> {
  const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/MomentumRoutine/runs/recent?limit=${limit}`, {
    headers: routineHeaders(),
  });
  if (!res.ok) throw new Error('Failed to load recent routine runs');
  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}

export interface RoutineStats {
  total: number;
  active: number;
  paused: number;
}

// All-time totals across ALL of the current user's routines, independent of
// whatever page/search filter the list UI has applied — backs the
// /momentum-routines right-sidebar KPI cards.
export async function getRoutineStats(): Promise<RoutineStats> {
  const res = await fetch(`${process.env.REACT_APP_Auth_Url}/api/MomentumRoutine/stats`, {
    headers: routineHeaders(),
  });
  if (!res.ok) throw new Error('Failed to load routine stats');
  const json = await res.json();
  return {
    total: json?.total ?? 0,
    active: json?.active ?? 0,
    paused: json?.paused ?? 0,
  };
}
